module.exports = __webpack_public_path__ + "static/media/ost_2.68e6aa40.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ost_2.png
// module id = 1042
// module chunks = 0